import type { GetStaticProps, InferGetStaticPropsType } from 'next'

import SecondaryPage from '~/components/secondaryPage/SecondaryPage'
import { readToken } from '~/lib/sanity.api'
import { getClient } from '~/lib/sanity.client'
import {
  getNavigation,
  getRentANode,
  Navigation,
  RentANode,
} from '~/lib/sanity.queries'
import type { SharedPageProps } from '~/pages/_app'

import RentOne from '../components/secondaryPage/artwork/RentOne'
import RentThree from '../components/secondaryPage/artwork/RentThree'
import RentTwo from '../components/secondaryPage/artwork/RentTwo'

export const getStaticProps: GetStaticProps<
  SharedPageProps & {
    navigation: Navigation
    content: RentANode
  }
> = async ({ draftMode = false }) => {
  const client = getClient(draftMode ? { token: readToken } : undefined)
  const navigation = await getNavigation(client)
  const content = await getRentANode(client)

  return {
    props: {
      draftMode,
      token: draftMode ? readToken : '',
      navigation,
      content,
    },
  }
}

export default function RentPage(
  props: InferGetStaticPropsType<typeof getStaticProps>,
) {
  const navigation = props.navigation
  const content = props.content

  return (
    <SecondaryPage
      content={content}
      title="Rent a Node"
      navigation={navigation}
      howItWorksArtwork={[
        <RentOne key="rent-hiw-1" />,
        <RentTwo key="rent-hiw-2" />,
        <RentThree key="rent-hiw-3" />,
      ]}
    />
  )
}
